import React from 'react';
import { Switch } from '@mui/material';
import {
  FormRow,
  FormFieldWrapper,
  FormLabel,
  FormRowProps
} from '../form-input';

export interface SwitchFieldProps extends FormRowProps {
  label: string;
  value?: boolean;
  onChange: (checked: boolean) => void;
  name?: string;
}

export function SwitchField(props: SwitchFieldProps) {
  const { label, value, onChange, name, ...formRowProps } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <FormRow {...formRowProps}>
      <FormLabel>{label}</FormLabel>
      <FormFieldWrapper>
        <Switch
          name={name}
          color="primary"
          onChange={handleChange}
          checked={value}
        />
      </FormFieldWrapper>
    </FormRow>
  );
}
